import BigNumber from 'bignumber.js';
import Vue from 'vue';
import store from '../store';

export default class GameEvent {
    constructor(options) {
        this.name = '';
        this.id = '';
        this.type = 'shop';
        this.shop = null; //shop name or 'allShops'
        this.isApplied = false;
        this.cost = 0.0;
        this.bonus = 0.0;
        this.bonusFactor = 0.0;
        this.bonusPercent = 0;
        this.duration = 0;
        this.bonusType = 'decreaseProductionTime';
        this.description = null;
        this.html = '';
        this.costs = 0;
        this.singleCost = 0;
        this.bonusFactorType = '';
        this.isAvailable = () => true;
        Object.assign(this, options);
    }

    getDescription() {
        if (this.description !== null) {
            return Vue.i18n.translate(this.description);
        }
        switch (this.bonusType) {
        case 'decreaseProductionTime':
            return Vue.i18n.translate('Decreases the production time for {{shop}} by {{factor}}', {
                shop:   Vue.i18n.translate(this.shop),
                factor: this.bonusFactor
            });
        case 'increaseEarnings':
            return Vue.i18n.translate('Increases the earnings for {{shop}} by {{factor}}', {
                shop:   Vue.i18n.translate(this.shop),
                factor: this.bonusFactor
            });
        default:
            return '';
        }
    }

    /**
     *
     * @param {number}min
     * @param {number}max
     * @returns {number}
     */
    getRandomTimeSpan(min, max) {
        return Math.floor(Math.random() * (max - min) + min);
    }

    /**
     * @return {Promise}
     */
    apply() {
        let affectedShops = null,
            applied       = false,
            // skip          = false,
            totalAmount   = 0;
        if (this.shop !== null) {
            affectedShops = this.shop === 'all'
                ? store.getters.allShops
                : [store.getters.getShopByID(this.shop)];
        }
        if (Object.prototype.hasOwnProperty.call(this, 'bonusFactorType')) {
            if (Object.prototype.hasOwnProperty.call(this, 'singleCost') && this.bonusFactorType === 'allShopsAmount') {
                totalAmount += store.getters.getTotalBranchCount;
                if (totalAmount > 0) {
                    this.cost = new BigNumber((totalAmount * this.singleCost).toString());
                }
            } else if (this.bonusFactorType === 'currentBalance' && Object.prototype.hasOwnProperty.call(this, 'bonusFactor')) {
                // this.cost = this.game.getBalance(false).times(this.bonusFactor);
                this.cost = store.getters.totalBalance.times(this.bonusFactor);
            }
        }
        switch (this.bonusType) {
        case 'decreaseBalance':
            store.commit({ type: 'DECREASE_BALANCE', amount: this.cost });
            applied = true;
            break;
        case 'increaseBalance':
            store.commit({ type: 'INCREASE_BALANCE', amount: this.cost });
            applied = true;
            break;
        case 'increasePrice':
            // decrease the build price by n percent
            if (affectedShops !== null && this.bonusPercent !== 0) {
                affectedShops.forEach(shop => {
                    store.commit({
                        type:      'MODIFY_SHOP_ATTRIBUTE',
                        shop,
                        attribute: 'costMultiplier',
                        value:     shop.costMultiplier + (shop.costMultiplier / (100 / this.bonusPercent))
                    });
                });
                applied = true;
            } else if (affectedShops !== null && this.bonusFactor !== 0) {
                affectedShops.forEach(shop => {
                    store.commit({
                        type:      'MODIFY_SHOP_ATTRIBUTE',
                        shop,
                        attribute: 'costMultiplied',
                        value:     shop.costMultiplier / this.bonusFactor
                    });
                });
                applied = true;
            }
            break;
        case 'decreaseEarnings':
            if (affectedShops !== null && this.bonusFactor !== 0) {
                affectedShops.forEach(shop => {
                    store.commit({
                        type:      'MODIFY_SHOP_ATTRIBUTE',
                        shop,
                        attribute: 'earningsMultiplier',
                        value:     shop.earningsMultiplier * this.bonusFactor
                    });
                });
                applied = true;
            }
            break;
        case 'modifyProductionTime':
            if (affectedShops !== null && this.bonusFactor !== 0) {
                affectedShops.forEach(shop => {
                    store.commit({
                        type:      'MODIFY_SHOP_ATTRIBUTE',
                        shop,
                        attribute: 'coolDown',
                        value:     shop.coolDown / this.bonusFactor
                    });
                });
                applied = true;
            }
            break;
        case 'strike':
            //@todo: save strike status.. otherwise you can just close the window and shops start producing again
            this.duration = this.getRandomTimeSpan(60 * 1000, 5 * 60 * 1000);
            store.commit({ type: 'SET_STRIKE', onStrike: true, duration: this.duration });
            applied = new Promise(resolve => {
                setTimeout(() => {
                    store.commit({ type: 'SET_STRIKE', onStrike: false, duration: 0 });
                    resolve(true);
                }, this.duration);
            });
            break;
        default:
            break;
        }

        return new Promise((resolve, reject) => {
            if (applied !== false && this.isAvailable()) {
                resolve({ isApplied: applied });
            } else {
                reject(new Error('Event not available'));
            }
        });
    }
}
